import { useTheme } from '@mui/material/styles';
import { useMediaQuery, Button, Stack } from '@mui/material';
import Google from '../../assets/icons/google.svg';
import { useGoogleLogin } from '@react-oauth/google';
import { useNotification } from '../../hooks/NotificationContext';

const SocialLogins = ({ handleSubmit }) => {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('xs'));
  const { addNotification } = useNotification();
  const onSuccessGoogle = async (response) => {
    try {
      const user = {
        first_name: response.given_name,
        last_name: response.family_name,
        email: response.email,
        platform: 'google',
        password: process.env.REACT_APP_PASSWORD_SECRET_KEY || 'googlepassword',
      };
      handleSubmit(user);
    } catch (error) {
      console.log(error);
      addNotification('error', 'Google login failed. Please try again');
    }
  };

  const performLogin = async (token) => {
    try {
      const data = await fetch(
        `https://www.googleapis.com/oauth2/v3/userinfo?access_token=${token}`
      );
      const resp = await data.json();
      onSuccessGoogle(resp);
    } catch (e) {
      addNotification('error', 'Google login failed. Please try again');
    }
  };

  const googleLogin = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      performLogin(tokenResponse.access_token);
    },
    scope: 'profile email',
  });

  return (
    <Stack
      direction="row"
      spacing={matchDownSM ? 1 : 2}
      justifyContent={matchDownSM ? 'space-around' : 'space-between'}
      sx={{
        '& .MuiButton-startIcon': {
          mr: matchDownSM ? 0 : 1,
          ml: matchDownSM ? 0 : -0.5,
        },
      }}>
      <Button
        size="large"
        variant="outlined"
        fullWidth={!matchDownSM}
        startIcon={<img src={Google} alt="Google" />}
        onClick={() => googleLogin()}>
        {!matchDownSM && 'Continue with Google'}
      </Button>
    </Stack>
  );
};

export default SocialLogins;
